import { FieldWrapper, Label, SingleCombobox } from '@commenda/kakashi';
import { TBaseHumanStepDefinition } from '@commenda/types';
import { TaskParty } from '@prisma/client';
import { useWorkflow } from '../../context/WorkflowContext';
import { TSelectedEntity } from '../../types/node';

export const HumanStepAssigneeConfig = ({
  selectedEntity,
}: {
  selectedEntity: TSelectedEntity;
}) => {
  const { workflow, setWorkflow } = useWorkflow();

  const selectedStep = workflow?.steps.find(
    (step) => step.id === selectedEntity.id
  ) as TBaseHumanStepDefinition;

  if (!selectedStep) return null;

  const assigneeTypeOptions = [
    {
      label: 'Client',
      value: TaskParty.CLIENT.toLowerCase(),
    },
    { label: 'Agent', value: TaskParty.AGENT.toLowerCase() },
    { label: 'Admin', value: TaskParty.ADMIN.toLowerCase() },
  ];

  const updateAssigneeConfig = (type: string) => {
    setWorkflow({
      ...workflow,
      steps: workflow?.steps.map((step) =>
        step.id === selectedEntity.id
          ? {
              ...step,
              assigneeConfig: {
                type,
              },
            }
          : step
      ),
    });
  };

  return (
    <FieldWrapper>
      <Label>Assignee Type</Label>
      <SingleCombobox
        options={assigneeTypeOptions}
        value={selectedStep.assigneeConfig?.type || ''}
        setValue={(value) => {
          updateAssigneeConfig(value);
        }}
      />
    </FieldWrapper>
  );
};
